<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Create new automation</h1>
        </template>
        <div class="mb-4 w-full">
            <div class="border-b border-gray-dark">
                <p class="font-bold rounded p-2">When...</p>
            </div>
            <automation-query-maker
                @change="syncQuery($event)"
                :options="options"
            ></automation-query-maker>

            <div class="border-b border-gray-dark">
                <p class="font-bold rounded p-2">Then...</p>
            </div>

            <action-selector
                :type="action"
                @change="selectAction($event)"
            ></action-selector>

            <div class="mt-2">
                <spell-maker
                    :type="action"
                    @change="syncSpell($event)"
                ></spell-maker>
                <p
                    class="text-destructive"
                    v-if="errors.spell && errors.spell.length > 0"
                >
                    {{ errors.spell[0] }}
                </p>
            </div>
        </div>

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Creating..."
                @click.native="submit"
            >
                Create
            </progressable-button>
            <button
                class="ml-2 py-2 px-4 rounded-md bg-primary-lightest"
                @click="close"
            >
                Cancel
            </button>
        </template>
    </modal-component>
</template>

<script>
import ActionSelector from "./ActionSelector.vue";
import SpellMaker from "./SpellMaker.vue";

export default {
    components: { SpellMaker, ActionSelector },
    props: {
        message: {
            type: Object,
            default: () => ({
                from_address: "",
                from_domain: "",
                subject: "",
            }),
        },
    },
    data() {
        return {
            loading: false,
            errors: {},
            action: "allow",
            options: {
                address: this.message.from_address,
                domain: this.message.from_domain,
                subject: this.message.subject,
            },
            query: [],
            spell: null,
        };
    },
    computed: {},
    methods: {
        syncQuery($event) {
            this.query = $event;
        },
        syncSpell($event) {
            this.spell = $event;
        },
        submit() {
            const action = this.action.split(".")[0];
            const payload = {
                type: "query",
                values: [this.query],
                action: action,
                spell: action === "spell" ? this.spell : null,
            };

            this.loading = true;
            this.errors = {};
            axios
                .post("/api/intents", payload)
                .then(() => {
                    this.$emit("resolve", payload);
                })
                .catch((err) => {
                    this.errors = err.response.data.errors;
                    this.loading = false;
                    console.error(err);
                })
                .then(() => {
                    this.loading = false;
                });

            // this.$emit('resolve', payload);
        },
        selectAction(action) {
            this.action = action;
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.label-joiner {
    @apply bg-primary-lighter text-primary rounded-full px-2 py-1 font-bold text-xs;
}
</style>
